
"use client"

import * as React from "react"

import { cn } from "@/lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  /** Render the field in error state (red border + ring). */
  error?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, ...props }, ref) => {
    return (
      <input
        type={type}
        {...(error ? { 'aria-invalid': true } : {})}
        className={cn(
          // `text-base md:text-sm`, not a bare `text-sm`: iOS Safari force-zooms
          // the page whenever a focused field renders below 16px, and it does
          // not zoom back out afterwards, so the buyer is left panning a
          // horizontally scrolled page mid-checkout. 16px on touch widths,
          // 14px from `md` up where no browser does this.
          "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base md:text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50",
          error && "border-destructive focus-visible:ring-destructive",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
